import React from 'react';
import Icon from '../../../components/AppIcon';

const PaymentHistoryCard = ({ payments }) => {
  if (!payments || payments?.length === 0) return null;

  const getMethodIcon = (method) => {
    const icons = {
      'efectivo': 'Banknote',
      'tarjeta': 'CreditCard',
      'transferencia': 'ArrowRightLeft'
    };
    return icons?.[method] || 'DollarSign';
  };

  return (
    <div className="bg-card rounded-xl shadow-elevation-2 p-4 md:p-6">
      <div className="flex items-center gap-2 mb-4 md:mb-6">
        <Icon name="History" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg font-semibold text-foreground">
          Historial de Pagos
        </h3>
      </div>
      <div className="space-y-3">
        {payments?.map((payment, index) => (
          <div
            key={index}
            className="flex items-center justify-between gap-4 p-3 bg-muted/50 rounded-lg"
          >
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                <Icon
                  name={getMethodIcon(payment?.method)}
                  size={20}
                  color="var(--color-primary)"
                />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground capitalize">
                  {payment?.method}
                </p>
                <p className="text-xs md:text-sm text-muted-foreground">
                  {new Date(payment.date)?.toLocaleString('es-ES', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="text-sm md:text-base font-bold text-success whitespace-nowrap">
                ${payment?.amount?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
              </p>
              {payment?.change > 0 && (
                <p className="text-xs text-muted-foreground">
                  Cambio: ${payment?.change?.toLocaleString('es-ES', { minimumFractionDigits: 2 })}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PaymentHistoryCard;